
import Testimonial from "@/components/Testimonial";

interface TestimonialData {
  quote: string;
  name: string;
  business: string;
}

const TestimonialsSection = () => {
  const testimonials: TestimonialData[] = [
    {
      quote: "Depois que fiz o SEO local, minha pizzaria recebe 3x mais pedidos por telefone. Valeu cada centavo investido!",
      name: "João Silva",
      business: "Dono de pizzaria em São Paulo"
    },
    {
      quote: "Passei a aparecer no topo do Google e dobrei os atendimentos em apenas três meses. Estou impressionada com os resultados!",
      name: "Camila Santos",
      business: "Psicóloga em Florianópolis"
    },
    {
      quote: "Minha oficina mecânica estava quase fechando as portas. Com o SEO local, agora aparecemos nas buscas e o movimento aumentou 70%.",
      name: "Roberto Oliveira",
      business: "Proprietário de oficina em Belo Horizonte"
    }
  ];

  return (
    <section id="depoimentos" className="py-20 px-6 md:px-12 bg-gradient-to-br from-blue-50 to-blue-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-seo-primary to-seo-secondary">O que nossos clientes dizem</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Veja como o SEO Local tem transformado negócios como o seu e gerado resultados concretos para empresários de diversos segmentos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              name={testimonial.name}
              business={testimonial.business}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
